import Component from ".";
import authRoles from "../../utils/auth.roles";
const HomeRoutes = {
  auth: authRoles.user,
  kyc: false,
  mfaNotRequired: true, 
  routes: [
    {
      path: "/home",
      component: Component,
      exact: true,
    },
  ],
};
export default HomeRoutes;
